import { render } from "./RootElement.vue?vue&type=template&id=2f33d984"
import script from "./RootElement.vue?vue&type=script&lang=js"
export * from "./RootElement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__